// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"256":"de29a737","270":"234dc4ba","473":"54b979f3","972":"6b4d635a"}[chunkId] + ".css";
};